
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/RBhu",
      function () {
        return require("private-next-pages/RBhu/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/RBhu"])
      });
    }
  